import React from 'react';
import styled from 'styled-components';
import Section from './shared/Section';
import { TextLine } from './shared/Basics.js';


const Wrapper = styled.div`

`;

const Question = styled.div`
  font-weight: bold;
  margin-bottom: 20px;
`;


const FAQBody = styled.div`
  width: 95%;
  margin: 0px auto 50px auto;
`;

const TabbedSpace = styled.span`
  display: inline-block;
  min-width: 100px;
`;


const FAQSection = (props) => {
  return (
    <Wrapper>
      <Question>{props.question}</Question>
      <FAQBody>{props.children}</FAQBody>
    </Wrapper>
  );
}

const FAQ = () => {
  return (
    <Section title='Frequently Asked Questions' id='faq'>
      <FAQSection question='What should I wear?'>
        Our wedding will be formal / cocktail attire. Our wedding is an "East Meets West" wedding that celebrates our unique blend of backgrounds and experiences.
        <br /><br />
        Feel free to wear the formal attire from whichever background you wish. We do ask that you observe the etiquette of the culture that your attire matches.
        If wearing an eastern style attire, the color of bright red is usually reserved for the bride and groom. If wearing a western style attire, the color white is usually reserved.
      </FAQSection>
      <FAQSection question='Can I bring a guest?'>
        Absolutely! However, we will only be able to accommodate those who RSVP before the event. If you wish to bring a guest, make sure you add them on your RSVP! 
      </FAQSection>
      <FAQSection question='Will the ceremony be taking place indoors or outdoors?'>
        The ceremony will be outdoors and the reception will be indoors.
      </FAQSection>
      <FAQSection question='What time should I arrive?'>
        We recommend that you arrive at least half an hour before the start of the ceremony to make sure everyone is on time and we can get the party started as scheduled! And to enjoy a glass of Sangria!
      </FAQSection>
      <FAQSection question='What is a tea ceremony?'>
        A tea ceremony is a traditional Chinese wedding event where the bride and the groom pay respects to their parents and family members by serving them tea. It's an important private event reserved for family members.
      </FAQSection>
      <FAQSection question='What if I cannot make it to the wedding?'>
        We will be sad that we can't celebrate with you. Our videographers will stream the wedding ceremony on Zoom:
        <p>
          <TextLine>Join Zoom Meeting</TextLine>
          <TextLine>
            <a href="https://us02web.zoom.us/j/89188377480?pwd=N1Zmak04WWE3c2xwcGdHZGt6RWtGdz09">
              https://us02web.zoom.us/j/89188377480?pwd=N1Zmak04WWE3c2xwcGdHZGt6RWtGdz09
            </a>
          </TextLine>
        </p>
        <p>
          <TextLine><TabbedSpace>Meeting ID: </TabbedSpace> 891 8837 7480 </TextLine>
          <TextLine><TabbedSpace>Passcode: </TabbedSpace> 983276</TextLine>
        </p>
      </FAQSection>
    </Section>
  );
}

export default FAQ;
